import React from "react";
import { useDispatch } from "react-redux";
import { setTradeModalOpen } from "../../store/Slices/globalSymbolSlice";
import TradeModal from "../../components/modal/trading/TradingModal";
import { Box, IconButton, Typography, Portal, Paper } from "@mui/material";
import { CloseSharp } from "@mui/icons-material";
import Draggable from 'react-draggable';

const WatchlistTrade = ({ openNewOrder, setOpenNewOrder }) => {
  console.log(openNewOrder);
  
  const dispatch = useDispatch();
  const handleCloseCreateOrderPanel = () => {
    dispatch(setTradeModalOpen(false));
  };

  const handleClose = (Uid) => {
    const newArr = openNewOrder.filter(symbol => symbol.Uid !== Uid)
    console.log(newArr, Uid);

    setOpenNewOrder(newArr)
  }

  return (
    <>
      {
        openNewOrder?.map(item => {
          return <Portal>
            <Draggable handle=".drag-handle" onStop={e => console.log(e)}>
              <Paper elevation={4} sx={{ position: "absolute", top: 100, left: 100, width: 400, zIndex: 1300, border: "1px solid #ccc", }}>
                <Box className="drag-handle" display="flex" alignItems="center" justifyContent="space-between" px={2} py={1} sx={{ backgroundColor: "var(--primary)", cursor: "move", }}>
                  <Typography variant="body2">New Order </Typography>
                  <IconButton size="small" onClick={e => handleClose(item.Uid)}><CloseSharp fontSize="small" /></IconButton>
                </Box>
                <Box>
                  <TradeModal symbol={item.symbolId} onClose={handleCloseCreateOrderPanel} showCloseButton={false} />
                </Box>
              </Paper>
            </Draggable>
          </Portal>
        })
      }
    </>
  );
};

export default WatchlistTrade;
